import { defineComponent as _defineComponent } from 'vue'
import { THGCO2Equivalent } from '@/interfaces/thg/THGCO2Equivalent';
    import { computed } from 'vue';

    interface Props {
        value: THGCO2Equivalent;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGCO2EquivalentForm',
  props: {
    value: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'input', equivalent: THGCO2Equivalent): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as {
        value: THGCO2Equivalent;
    };

    

    

    const equivalent = computed<THGCO2Equivalent>({
        get() {
            return props.value;
        },
        set(newVal: THGCO2Equivalent) {
            emit('input', newVal);
        },
    });

return { __sfc: true,props, emit, equivalent }
}

})